import log from '../utils/log'
import { AdminTransitIntegration } from './admin_transit_integration.js'
import { AdminTransitDisplay } from './admin_transit_display.js'
import { Pagination } from 'tranzito_utils_js'

export class AdminBase {
  initAdminReports () {
    const urlParams = new URLSearchParams(window.location.search)

    $('.companyTab a').on('click', e => {
      // Because it takes a lil bit for the active company to change, and timeout was easier than hooking into bootstrap
      window.setTimeout(() => {
        const company = $('.companyTab a.active').attr('data-company')
        urlParams.delete('company_id') // remove it if it exists
        urlParams.append('company_id', company)
        // Update the address bar to include the current company
        history.replaceState(
          {},
          '',
          `${location.pathname}?${urlParams.toString()}`
        )
      }, 1000)
    })
  }

  kioskRoomMembershipDiscount () {
    // Enable the membershipKindSelect changer
    $('.membershipKindSelect').on('change', e => {
      if ($('.membershipKindSelect').val() == 'per_plan') {
        $('.credit_input').collapse('hide')
        $('.per_plan_input').collapse('show')
        $('.credit_input input').val('')
      } else {
        $('.credit_input').collapse('show')
        $('.per_plan_input').collapse('hide')
        $('.per_plan_input input').val('')
      }
    })
  }

  initNestedFields () {
    log.debug('nested field init')
    // We don't need to do anything except slide the input up, because the label is on it.
    $('form').on('click', '.remove-fields', function (event) {
      // For this to work, the top level element in the nested fields needs to have the class "nested-field"
      $(this)
        .parents('.nested-field')
        .collapse('hide')
    })

    $('form').on('click', '.add-fields', function (event) {
      event.preventDefault()
      log.debug('add fields')
      const $target = $('.add-fields')
      const time = new Date().getTime()
      const regexp = new RegExp($target.data('id'), 'g')
      // Potentially could use classnames to determine placement of new field
      $target.before($target.data('fields').replace(regexp, time))
      // Need to re-load fancy selects here, if we ever add forms with fancy selects
    })
  }

  initAdminPaymentForm () {
    $('#purchase_payment_method').on('change', e => {
      let value = $('#purchase_payment_method').val()
      // GOTTA REVISE ALL THIS AND MAKE IT WORK!!
      if (value === 'cash') {
        window.paymentType = 'cash'
        $('.admin-submit-payment-cash').collapse('show')
        $('.admin-submit-payment-square').collapse('hide')
      } else {
        window.paymentType = 'square'
        $('.admin-submit-payment-cash').collapse('hide')
        $('.admin-submit-payment-square').collapse('show')
      }
    })
  }

  initAdminExpandPurchases () {
    $('#expandPurchaseTable .purchaseLink').on('click', e => {
      e.preventDefault()
      const $target = $(e.target)
      const $purchaseRow = $target.parents('tr')
      const previousPurchaseId = $('#expandPurchaseTable').attr(
        'data-purchaseIdExpanded'
      )
      const newPurchaseId = $purchaseRow.attr('data-purchaseId')

      if (previousPurchaseId == newPurchaseId) {
        log.debug('same row')
        return false
      }
      // tables don't expand and collapse well, so I created an extra wrapper inside the table
      // and set a timeout so the first row has a chance to collapse
      $(
        '#expandPurchaseTable .expand-purchase-row.show .purchase-data, #expandPurchaseTable .expand-purchase-row.show'
      ).collapse('hide')
      $('#expandPurchaseTable .non-expand-purchase-row').removeClass(
        'highlighted-row'
      )
      $('#expandPurchaseTable').attr('data-purchaseIdExpanded', newPurchaseId)
      window.setTimeout(() => {
        $('#expandPurchaseTable .expand-purchase-row.show').collapse('hide')
        $purchaseRow.addClass('highlighted-row')
        $(
          `#expandPurchaseTable #expandPurchaseRow-${newPurchaseId}, #expandPurchaseTable #expandPurchaseRow-${newPurchaseId} .purchase-data`
        ).collapse('show')
      }, 300)
    })
  }

  initAdminSearchSelect () {
    window.initialValue = $('#admin_other_navigation').val()
    // On change, if the change is for something new and is an actual value, redirect to that page
    $('#admin_other_navigation').on('change', e => {
      let newValue = $('#admin_other_navigation').val()
      if (newValue != window.initialValue && newValue.length > 0) {
        location.href = newValue
      }
    })
  }

  initPerPageSelect () {
    window.pagination = new Pagination()
    window.pagination.init()
  }

  initToggleData () {
    // Make it possible to manually override toggling data
    if (window.overrideToggleData === true) {
      return true
    }
    const btnSelector = "[data-target='.data-cell']"
    if (localStorage.getItem('toggleDataCells') == 'true') {
      $('.data-cell').collapse('toggle')
      $(btnSelector).addClass('active')
    }
    $(btnSelector).on('click', e => {
      if (localStorage.getItem('toggleDataCells') == 'true') {
        localStorage.removeItem('toggleDataCells')
        $(btnSelector).removeClass('active')
      } else {
        localStorage.setItem('toggleDataCells', 'true')
        $(btnSelector).addClass('active')
      }
    })
  }

  init () {
    log.debug('in admin')

    this.initAdminSearchSelect()

    this.initPerPageSelect() // always initialize just in case

    this.initToggleData()

    if ($('.membershipKindSelect').length) {
      this.kioskRoomMembershipDiscount()
    }

    if ($('#adminPaymentForm').length) {
      this.initAdminPaymentForm()
    }

    if ($('#expandPurchaseTable').length) {
      this.initAdminExpandPurchases()
    }

    if ($('.add-fields').length) {
      this.initNestedFields()
    }

    if ($('#adminReportsPage').length) {
      this.initAdminReports()
    }

    if ($('#transitIntegrationForm').length) {
      window.adminTransitIntegration = new AdminTransitIntegration()
      adminTransitIntegration.init()
    }

    if ($('#transitDisplayForm').length) {
      window.adminTransitDisplay = new AdminTransitDisplay()
      adminTransitDisplay.init()
    }

    if ($('#addCustomerParkingModal').length) {
      // Set focus on the fake action modal, so that you can just hit enter
      $('.modal#addCustomerParkingModal').on('show.bs.modal', () => {
        window.setTimeout(() => {
          $('#addCustomerParkingModal .form-control:first').focus()
        }, 200)
      })
    }
  }
}
